var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "composite-selector" }, [
    _c("div", { staticClass: "label" }, [
      _c("span", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm.title == "假期类型"
        ? _c(
            "span",
            {
              staticClass: "cursor",
              staticStyle: { color: "#1890ff" },
              on: {
                click: function ($event) {
                  return _vm.goUrl()
                },
              },
            },
            [_vm._v("修改")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "info",
      domProps: { innerHTML: _vm._s(_vm.value) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }